export const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL || 'http://localhost:1246';
export const ORCHESTRATOR_API_URL = process.env.REACT_APP_ORCHESTRATOR_API_URL || 'http://localhost:1245';
export const STATIC_INFERENCE_API_URL = process.env.REACT_APP_STATIC_INFERENCE_API_URL || 'https://api.staticinference.sentioweb.com';

export const STATIC_INFERENCE_ENDPOINTS = {
    GUIDELINES: {
        BASE: '/api/v1/guidelines/pipeline',
        UPLOAD_JSON: '/api/v1/guidelines/pipeline/upload-json',
        UPLOAD_PDF: '/api/v1/guidelines/pipeline/upload-pdf',
        SUBMIT_PIPELINE: '/api/v1/guidelines/pipeline',
    }
};